import { IAppState } from '../../redux';
import { IBetPosition } from '../../redux/reducers';
import { selectActivePackageServiceId, selectActiveServiceId, selectIsPromotionPackageSelected } from '../publishTerms';
import { selectBetPositionByServiceId } from './selectBetPositionByServiceId';

export function selectBetPosition(state: IAppState): IBetPosition | null {
  const activeServiceId = selectActiveServiceId(state);
  const activePackageServiceId = selectActivePackageServiceId(state);
  const isPromotionPackageSelected = selectIsPromotionPackageSelected(state);

  // Если выбран пакет на топ/премиум, позицию определяем по услуге пакета (карточки услуг в этом случае не отображаются)
  const serviceId = isPromotionPackageSelected ? activePackageServiceId : activeServiceId;

  if (!serviceId) {
    return null;
  }

  return selectBetPositionByServiceId(serviceId, state);
}
